/* eslint-disable camelcase */
import React from 'react';
import { PropTypes } from 'prop-types';
import { get, isEmpty } from 'lodash';
import { Icons, CustomValidation, Button, FlexRow, FlexCol } from 'sarsaparilla';

const propTypes = {
  index: PropTypes.number,
  removeLeader: PropTypes.func,
  leader: PropTypes.shape({
    first_name: PropTypes.string,
    email: PropTypes.string,
    cell_phone: PropTypes.string,
    last_name: PropTypes.string
  }),
  className: PropTypes.string,
  alternateLeaderValidatorMethod: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  pActions: PropTypes.shape().isRequired,
  reservationId: PropTypes.string,
  paths: PropTypes.shape({
    email: PropTypes.string,
    last_name: PropTypes.string,
    first_name: PropTypes.string,
    alt_group_detail: PropTypes.string
  })
};

const defaultProps = {
  isDisabled: false,
  className: '',
  paths: {
    email: 'email',
    last_name: 'last_name',
    first_name: 'first_name',
    alt_group_detail: 'alt_permit_holders'
  }
};

export default class AlternatePermitHolderNameEmailEntry extends React.Component {
  constructor(props) {
    super(props);
    this.onClickRemove = this.onClickRemove.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  onClickRemove() {
    const index = parseInt(this.props.index, 10);
    this.props.removeLeader(index);
  }

  handleChange(event) {
    const input = event.target.value;
    const key = event.target.name;
    const path = `${this.props.paths.alt_group_detail}[${this.props.index}].${key}`;
    this.props.pActions.updatePendingReservation(this.props.reservationId, path, input);
  }

  handleValidation(key, isInvalid, error) {
    const path = `${this.props.reservationId}_${this.props.paths.alt_group_detail}[${this.props.index}].${key}`;
    if (isInvalid) {
      this.props.pActions.formValidationChange(path, error);
    } else {
      this.props.pActions.formValidationChange(path, null);
    }
  }

  nameValidatorMethod(value) {
    return isEmpty(value);
  }

  renderRemoveLeaderButton() {
    if (this.props.isDisabled) {
      return <div />;
    }

    return (
      <div className="alternate-group-leader">
        <Button
          type="button"
          className="remove-leader-link"
          onClick={this.onClickRemove}
          iconBeforeElement={<Icons.IconCloseCircle />}
          screenReaderTextBefore="Close" />
      </div>
    );
  }

  render() {
    const { leader } = this.props;
    return (
      <div className="permit-alt-input-wrap m-1">
        <div className="permit-alt-header-wrap">
          <div className="permit-alt-header">Alternate Permit Holder #{this.props.index + 1}</div>
          {this.renderRemoveLeaderButton()}
        </div>

        <FlexRow className="mb-1">
          <FlexCol xs={12} md={6} lg={4}>
            <label htmlFor="other-first_name">First Name</label>
            <input
              id="other-first_name"
              type="text"
              name={this.props.paths.first_name}
              className={this.props.className}
              value={get(leader, this.props.paths.first_name, '')}
              onChange={this.handleChange}
              readOnly={this.props.isDisabled}
              disabled={this.props.isDisabled} />
            <CustomValidation
              value={get(leader, this.props.paths.first_name, '')}
              displayInSummary
              customValidator={this.nameValidatorMethod}
              onValidated={this.handleValidation.bind(this, this.props.paths.first_name)}
              controlLabel="Alternate Permit Holder First Name" />
          </FlexCol>
          <FlexCol xs={12} md={6} lg={4}>
            <label htmlFor="other-last_name">Last Name</label>
            <input
              id="other-last_name"
              type="text"
              name={this.props.paths.last_name}
              className={this.props.className}
              value={get(leader, this.props.paths.last_name, '')}
              onChange={this.handleChange}
              readOnly={this.props.isDisabled}
              disabled={this.props.isDisabled} />
            <CustomValidation
              value={get(leader, this.props.paths.last_name, '')}
              displayInSummary
              customValidator={this.nameValidatorMethod}
              onValidated={this.handleValidation.bind(this, this.props.paths.last_name)}
              controlLabel="Alternate Permit Holder Last Name" />
          </FlexCol>
          <FlexCol xs={12} md={12} lg={4}>
            <label htmlFor="other-email">Email Address</label>
            <input
              id="other-email"
              type="text"
              name={this.props.paths.email}
              className={this.props.className}
              value={get(leader, this.props.paths.email, '')}
              onChange={this.handleChange}
              readOnly={this.props.isDisabled}
              disabled={this.props.isDisabled} />
            <CustomValidation
              value={get(leader, this.props.paths.email, '')}
              displayInSummary
              customValidator={this.props.alternateLeaderValidatorMethod}
              onValidated={this.handleValidation.bind(this, this.props.paths.email)}
              controlLabel="Alternate Permit Holder Email Address" />
          </FlexCol>
        </FlexRow>
      </div>
    );
  }
}

AlternatePermitHolderNameEmailEntry.propTypes = propTypes;
AlternatePermitHolderNameEmailEntry.defaultProps = defaultProps;
